import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetFeatureFlagsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetFeatureFlagsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setFeatureFlags = (request: SetFeatureFlagsRequest, options?: CashRequestOptions) =>
  post<SetFeatureFlagsRequest, SetFeatureFlagsResponse>('/2.0/cash/set-feature-flags', request, {
    ...options,
    rejectOnError: true,
  })
